/* global localStorage */
import {
  USER_ACCESS_TOKEN,
} from '../constants';

const userWidgetMiddleware = {
  configureApi: () => null,
  loginSuccess: (user, dispatch) => {
    localStorage.setItem(USER_ACCESS_TOKEN, user.accessToken);
  },
  logoutSuccess: (dispatch) => {
    localStorage.removeItem(USER_ACCESS_TOKEN);
  },
};

export default userWidgetMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/user-widget.js